import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import {
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import { spacing } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useGetTrustedPartnerInvitesQuery } from "../../../redux/slices/indexApiSlice";
import { ITrustedPartnerInvite } from "../../../types/trustedpartner";
import { DialogMode } from "../../../types/dialogmode";
import TrustedPartnerInviteDialog from "../../../components/dialogs/TrustedPartnerInviteDialog";
import Invite from "./Invite";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

function TrustedPartners() {
  const { t } = useTranslation();

  const { data: invites = [], refetch } = useGetTrustedPartnerInvitesQuery();

  return (
    <React.Fragment>
      <Helmet title={t("Trusted Partners")!} />

      <Grid justifyContent="space-between" container spacing={10}>
        <Grid>
          <Typography variant="h3" gutterBottom display="inline">
            {t("Trusted Partners")}
          </Typography>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container direction="column" gap={6}>
        <Grid>
          <TrustedPartnerInviteDialog mode={DialogMode.Add} refetch={refetch} />
        </Grid>

        <Grid>
          <Grid container spacing={6}>
            {invites?.map((invite: ITrustedPartnerInvite) => {
              return (
                <Grid size={4}>
                  <Invite
                    key={`trusted-partner-invite-${invite.id}`}
                    invite={invite}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default TrustedPartners;
